(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const stickyForm = document.getElementById("sticky-atc-form");
  const stickyVariantId = document.getElementById("sticky-variant-id");
  const stickyQty = document.getElementById("sticky-qty");
  const stickyPrice = document.getElementById("sticky-price");
  const stickyButton = document.getElementById("sticky-add-to-cart");

  // Sync variant with theme product form
  const variantInputs = document.querySelectorAll('input[name="id"]');
  variantInputs.forEach(function (input) {
    input.addEventListener("change", function () {
      stickyVariantId.value = this.value;

      // price update
      const priceEl =
        document.querySelector("[data-product-price]") ||
        document.querySelector(".price-item--regular") ||
        document.querySelector(".product__price") ||
        null;
      if (priceEl) stickyPrice.innerHTML = priceEl.innerText.trim();
    });
  });

  // AJAX Add to cart
  stickyForm.addEventListener("submit", function (e) {
    e.preventDefault();
    stickyButton.disabled = true;
    stickyButton.innerText = "Adding...";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        id: stickyVariantId.value,
        quantity: parseInt(stickyQty.value) || 1
      })
    })
      .then(res => res.json())
      .then(data => {
        stickyButton.innerText = "Added ✓";
        setTimeout(() => {
          stickyButton.disabled = false;
          stickyButton.innerText = "Add to cart";
        }, 1500);
      })
      .catch(err => {
        stickyButton.innerText = "Error";
        setTimeout(() => {
          stickyButton.disabled = false;
          stickyButton.innerText = "Add to cart";
        }, 1500);
      });
  });
});

  } catch(e) { console.error(e); }
})();
})();
